import Api from './api'

export default {
  baseUrl: 'Partner',

  /**
   * searchByCountryAndDistance
   *
   * @param {string} countryCode
   * @param {number} postCode
   * @param {number} distance
   * @returns {Promise}
   */
  searchByCountryAndDistance (countryCode = 'DE', postCode, distance) {
    return fetch(`${Api.baseUrl}/${this.baseUrl}/ByPostcode/${countryCode}/${postCode}/${distance}`, {
      headers: {
        ...Api.baseHeader,
      }
    })
  },

  /**
   * verify
   *
   * @param {string} username
   * @param {string} password
   * @returns {Promise}
   */
  verify (username = '', password = '') {
    return Api.baseFetch(`${this.baseUrl}/Verify`, {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    })
  },

  /**
   * @param {string|number} partnerId
   * @param {string|number} loginId
   * @returns {Promise}
   */
  removeRole (partnerId, loginId) {
    return Api.baseFetch(`${this.baseUrl}/${partnerId}/Delegate/${loginId}`, {
      method: 'DELETE',
    })
  },
}
